module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('video-modal', {
    staticClass: "video-modal",
    attrs: {
      "show": _vm.showPlayer
    },
    on: {
      "hide": _vm.stop
    }
  }, [(!_vm.playerReady) ? _c('div', {
    staticClass: "loading-container vjs-waiting",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "vjs-loading-spinner",
    attrs: {
      "dir": "ltr"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerReady),
      expression: "playerReady"
    }],
    staticClass: "videojs-player",
    attrs: {
      "slot": "body"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "body"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": _vm.playerElement
    }
  }, [(_vm.record.url) ? _c('source', {
    attrs: {
      "src": _vm.record.url,
      "type": _vm.record.mimetype
    }
  }) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aeb9f60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/ModalRecordPlayer.vue
// module id = 1040
// module chunks = 1